
import { Tabs, TabPane, Collapse, CollapseItem } from 'element-ui';
import { HomeIcon, MapPinIcon } from 'vue-feather-icons';
import Carriers from '@/pages/cart/components/Carriers.vue';
import { TunnelHelper } from '@/helpers/TunnelHelper.js';

import addressMixin from '@/mixins/addressMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
export default {
  mixins: [addressMixin, carriersMixin, cartMixin],
  props: {},
  data() {
    return {
      // activeTab: "Home",
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.$store.state.carriers.activeTab;
      },
      set(value) {
        this.$store.commit('carriers/setActiveTab', value);
      },
    },
    idAddress() {
      return this.idAddressDelivery;
    },
    CarriersHome() {
      const list = this.carriers.filter((item) => {
        return item.CarrierType === 'AtHome';
      });

      return list;
    },
    CarriersRelayPoint() {
      const list = this.carriers.filter((item) => {
        return item.CarrierType === 'RelayPoint';
      });

      return list;
    },
    CarriersClickAndCollect() {
      const list = this.carriers.filter((item) => {
        return item.CarrierType === 'ClickAndCollect';
      });

      return list;
    },
    getIsMobile() {
      return this.$store.state.shared.wind.isMobile;
    },
    carrier() {
      return this.cart?.Shipping?.Carrier;
    },
  },
  methods: {
    async onTabChecked() {
      await this.autoSelectFirstCarrier(this.activeTab);
    },

    async autoSelectFirstCarrier(selectedTab) {
      const tabCarriers = this.carriers[selectedTab];

      if (tabCarriers && tabCarriers.length > 0) {
        const firstCarrier = tabCarriers[0];
        
        // Prevent re-selecting the same carrier unnecessarily
        if (this.carrier?.IdCarrier === firstCarrier.IdCarrier && this.carrier?.CarrierType !== 'RelayPoint') {
           return;
        }

        const params = {
          idCarrier: firstCarrier.IdCarrier,
          idAddress: this.idAddressDelivery,
          idAddressInvoice: this.idAddressInvoice || this.idAddressDelivery,
        };

        if (selectedTab === 'RelayPoint') {
          const tunnelHelper = new TunnelHelper(this.$http, this.$auth);
          try {
            const data = await tunnelHelper.getRelayPointsByIdAddressAndIdCarrier({
              idAddress: this.idAddressDelivery,
              idCarrier: firstCarrier.IdCarrier,
            });
            if (data.RelayPoints && data.RelayPoints.length > 0) {
              params.idRelayPoint = data.RelayPoints[0].Id;
              params.countryIsoCode = data.RelayPoints[0].CountryIsoCode || 'FR';
            }
          } catch (e) {
            console.log(e);
          }
        }

        try {
          if (params.idRelayPoint || selectedTab !== 'RelayPoint') {
            await this.cartService.setCarrierToCart(params);
            await this.cartService.fetchCart();
          }
        } catch (error) {
          console.log('error', error);
        }
      }
    },

    setCarrier(carrier) {},
  },
  watch: {
    carriers: {
      deep: true,
      async handler(value) {
        if (!this.carrier && this.carrierTypes?.length) {
          const firstTab = this.carrierTypes[0];
          await this.autoSelectFirstCarrier(firstTab);
        }
      },
    },
    carrierTypes(value) {
      if (value) {
        const activeCarrier = value.find((carrierType) => {
          return this.carriers[carrierType].find((carrier) => {
            return carrier?.IdCarrier === this.carrier?.IdCarrier;
          });
        });

        if (activeCarrier) {
          this.activeTab = activeCarrier;
        }
      }
    },
  },
  mounted() {
    // this.onTabChecked();
  },
  components: {
    Tabs,
    TabPane,
    HomeIcon,
    MapPinIcon,
    Carriers,
    Collapse,
    CollapseItem,
  },
};
